// extracted by mini-css-extract-plugin
export var cancelButton = "_pu-5";
export var content = "_pu-3";
export var createButton = "_pu-6";
export var drawerContainer = "_pu-0";
export var footer = "_pu-2";
export var header = "_pu-1";
export var orderFormColumn = "_pu-4";